import React from 'react';
import { connect } from 'react-redux';

import { firebase, db } from '../firebase';
import Api from '../services/api';
import AuthService from '../services/auth';

const withAuthentication = (Component) => {
  class WithAuthentication extends React.Component {
    componentDidMount() {
      const { onSetAuthUser, onSetUnreadCount } = this.props;

      firebase.auth.onAuthStateChanged(authUser => {
        let ucdUser = null;
        (new Api()).get('/users/current',{}, AuthService.getAuthCookie())
          .then(response => {
            ucdUser = response.user;
            db.userUnread(ucdUser.id)
              .on('value', (snap) => {
                const unreadCount = (snap.val() !== null)?Object.keys(snap.val()).length:0;
                onSetUnreadCount(unreadCount);
              });

            (authUser && ucdUser)
              ? onSetAuthUser(authUser, ucdUser)
              : onSetAuthUser(null, null);
          }).catch(() => {
            onSetAuthUser(null, null);
        });
      });


    }

    render() {
      return (
        <Component {...this.props}/>
      );
    }
  }

  const mapDispatchToProps = (dispatch) => ({
    onSetAuthUser: (authUser, ucdUser) => dispatch({ type: 'AUTH_USER_SET', authUser, ucdUser }),
    onSetUnreadCount: (count) => dispatch({type: 'SET_UNREAD_COUNT', unreadCount: count}),
  });

  return connect(null, mapDispatchToProps)(WithAuthentication);
}

export default withAuthentication;


// WEBPACK FOOTER //
// ./src/components/withAuth.js